<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
  <!--begin::Toolbar container-->
  <div
    id="kt_app_toolbar_container"
    class="app-container container-fluid d-flex flex-stack"
  >
    <!--begin::Page title-->
    <div
      class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
    >
      <!--begin::Title-->
      <div class="d-flex align-items-center">
        <h1 class="page-heading">
          <svg
            width="36"
            height="38"
            viewBox="0 0 36 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_373_934)">
              <path
                d="M4.60489 6.04201H8.77521C9.1081 6.04201 9.38048 5.76959 9.38048 5.43673V1.26638C9.38048 1.02433 9.23522 0.800305 9.00522 0.709573C8.78127 0.612708 8.521 0.667162 8.34549 0.836657L4.18119 5.00701C4.00564 5.18249 3.95118 5.44279 4.04801 5.66674C4.13882 5.89675 4.36276 6.04201 4.60489 6.04201Z"
                fill="#265D91"
              />
              <path
                d="M12.2618 21.9129V18.9894C12.2618 17.9881 13.0763 17.1736 14.0776 17.1736H14.8236L14.2934 16.6434C13.9505 16.3017 13.7614 15.846 13.7614 15.3607C13.7614 14.8754 13.9505 14.4197 14.2946 14.0769L16.3634 12.008C16.6719 11.68 17.1472 11.4778 17.6431 11.4778C18.1301 11.4778 18.587 11.6664 18.9287 12.008L19.4589 12.5383V11.7923C19.4589 10.791 20.2734 9.97647 21.2747 9.97647H23.3385V1.26677C23.3385 0.933843 23.0722 0.661499 22.7332 0.661499H10.486C10.5522 0.851977 10.5914 1.05502 10.5914 1.26677V5.43691C10.5914 6.43821 9.77686 7.25273 8.77556 7.25273H4.60542C4.39378 7.25273 4.19081 7.21343 4 7.14648V25.6473C4 25.9802 4.27234 26.2526 4.60528 26.2526H13.9076C13.8127 26.0304 13.7614 25.7902 13.7614 25.5416C13.7614 25.0563 13.9505 24.6006 14.2946 24.2578L14.823 23.7287H14.0776C13.0763 23.7287 12.2618 22.9142 12.2618 21.9129ZM10.6599 21.5943H7.63357C7.29902 21.5943 7.0283 21.3236 7.0283 20.989C7.0283 20.6545 7.29902 20.3838 7.63357 20.3838H10.6599C10.9945 20.3838 11.2652 20.6545 11.2652 20.989C11.2652 21.3236 10.9945 21.5943 10.6599 21.5943ZM10.6599 17.9627H7.63357C7.29902 17.9627 7.0283 17.692 7.0283 17.3574C7.0283 17.0228 7.29902 16.7521 7.63357 16.7521H10.6599C10.9945 16.7521 11.2652 17.0228 11.2652 17.3574C11.2652 17.692 10.9945 17.9627 10.6599 17.9627ZM10.6599 14.331H7.63357C7.29902 14.331 7.0283 14.0603 7.0283 13.7257C7.0283 13.3912 7.29902 13.1205 7.63357 13.1205H10.6599C10.9945 13.1205 11.2652 13.3912 11.2652 13.7257C11.2652 14.0603 10.9945 14.331 10.6599 14.331ZM10.6599 10.6994H7.63357C7.29902 10.6994 7.0283 10.4287 7.0283 10.0941C7.0283 9.75954 7.29902 9.48882 7.63357 9.48882H10.6599C10.9945 9.48882 11.2652 9.75954 11.2652 10.0941C11.2652 10.4287 10.9945 10.6994 10.6599 10.6994Z"
                fill="#265D91"
              />
              <path
                d="M31.3948 18.384H29.0706C28.9617 18.0572 28.8285 17.7364 28.6772 17.4337L30.3175 15.7874C30.5596 15.5514 30.5596 15.17 30.3175 14.934L28.2535 12.8639C28.0174 12.6279 27.6361 12.6279 27.4 12.8639L25.7537 14.5103C25.445 14.3529 25.1303 14.2258 24.8034 14.1168V11.7926C24.8034 11.4537 24.531 11.1873 24.1982 11.1873H21.2747C20.9418 11.1873 20.6694 11.4537 20.6694 11.7926V14.1168C20.3426 14.2258 20.0278 14.3529 19.7191 14.5103L18.0728 12.8639C17.9578 12.7489 17.8064 12.6884 17.643 12.6884C17.4856 12.6884 17.3283 12.7489 17.2193 12.8639L15.1493 14.934C14.9132 15.17 14.9132 15.5514 15.1493 15.7874L16.7956 17.4337C16.6382 17.7364 16.5111 18.0572 16.4022 18.384H14.0779C13.739 18.384 13.4727 18.6564 13.4727 18.9893V21.9128C13.4727 22.2457 13.739 22.5181 14.0779 22.5181H16.4022C16.5111 22.8449 16.6382 23.1597 16.7956 23.4684L15.1493 25.1147C14.9132 25.3508 14.9132 25.7321 15.1493 25.9682L17.2193 28.0321C17.4554 28.2742 17.8367 28.2742 18.0728 28.0321L19.7191 26.3918C20.0278 26.5431 20.3426 26.6763 20.6694 26.7853V29.1095C20.6694 29.4424 20.9418 29.7148 21.2747 29.7148H24.1982C24.531 29.7148 24.8034 29.4424 24.8034 29.1095V26.7853C25.1303 26.6763 25.445 26.5431 25.7537 26.3918L27.4 28.0382C27.509 28.1471 27.6664 28.2137 27.8237 28.2137C27.9871 28.2137 28.1385 28.1471 28.2535 28.0382L30.3175 25.9682C30.5596 25.7321 30.5596 25.3508 30.3175 25.1147L28.6772 23.4684C28.8285 23.1597 28.9617 22.8449 29.0706 22.5181H31.3948C31.7278 22.5181 32.0001 22.2457 32.0001 21.9128V18.9893C32.0001 18.6564 31.7278 18.384 31.3948 18.384ZM22.7334 24.3097C20.6088 24.3097 18.8778 22.5786 18.8778 20.448C18.8778 18.3235 20.6088 16.5925 22.7334 16.5925C24.8639 16.5925 26.595 18.3235 26.595 20.448C26.595 22.5786 24.8639 24.3097 22.7334 24.3097Z"
                fill="#265D91"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_373_934"
                x="0"
                y="0.661499"
                width="36"
                height="37.0533"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_373_934"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_373_934"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>

          Profil
        </h1>

        <!--begin::Menu-->
        <div
          class="menu menu-sub menu-sub-dropdown menu-column style-menu menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
          data-kt-menu="true"
        >
          <!--begin::Menu item-->
          <div class="menu-item px-3">
            <a
              href="#"
              data-bs-toggle="modal"
              data-bs-target="#kt_customers_export_modal"
              class="menu-link px-3"
              >Ajout unitaire</a
            >
          </div>
          <!--end::Menu item-->
          <!--begin::Menu item-->
          <div class="menu-item px-3">
            <a
              href="#"
              class="menu-link px-3"
              data-kt-customer-table-filter="delete_row"
              >Ajout en masse</a
            >
          </div>
          <!--end::Menu item-->
        </div>
      </div>
      <!--end::Title-->
      <!--begin::Breadcrumb-->
      <ul
        class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
      >
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">
          <a routerLink="/accueil" class="text-muted">Accueil</a>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item">
          <span class="bullet bg-gray-400 w-5px h-2px"></span>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">Profil</li>
        <!--end::Item-->
      </ul>
      <!--end::Breadcrumb-->
    </div>
    <!--end::Page title-->
    <!--begin::Actions-->

    <!--end::Actions-->
  </div>
  <!--end::Toolbar container-->
</div>
<div id="kt_app_content" class="app-content flex-column-fluid">
  <!--begin::Content container-->
  <div id="kt_app_content_container" class="app-container container-fluid">
    <!--begin::Layout-->
    <div class="d-flex flex-column flex-xl-row block1">
      <!--begin::Sidebar-->
      <div class="flex-column flex-lg-row-auto w-100 w-xl-500px mb-10">
        <!--begin::Card-->
        <div class="card-wrap mb-5 mb-xl-8">
          <!--begin::Card body-->
          <div class="card-body pt-15 position-relative">
            <!--begin::Summary-->
            <div class="d-flex flex-center flex-column mb-5">
              <!--begin::Avatar-->
              <div class="symbol symbol-150px symbol-circle mb-7">
                <img src="assets/media/avatars/300-1.jpg" alt="image" />
              </div>
              <!--end::Avatar-->
              <!--begin::Name-->
              <a class="fs-3 text-gray-800 text-hover-primary fw-bold mb-1"
                >{{ selectedCandidate?.first_name }}
                {{ selectedCandidate?.last_name }}</a
              >

              <!--end::Name-->
              <!--begin::Email-->
              <div class="status d-flex align-items-center">
                <div class="date_debut">
                  <span
                    >Le {{ formatDate(selectedCandidate?.created_at) }}</span
                  >
                </div>
              </div>
              <!--end::Email-->
            </div>
            <!--end::Summary-->
            <!--begin::Details toggle-->
            <div class="py-3 text-center title-bg">
              <div class="contact">Contact</div>
              <!--begin::Badge-->

              <!--begin::Badge-->
            </div>
            <!--end::Details toggle-->

            <!--begin::Details content-->
            <div class="contact-info pb-5 fs-6">
              <!--begin::Details item-->
              <div class="flex-space">
                <div class="contact-info-name">
                  <svg
                    width="26"
                    height="17"
                    viewBox="0 0 26 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.00143 6.82488C7.89531 6.82488 9.4306 5.29708 9.4306 3.41244C9.4306 1.5278 7.89531 0 6.00143 0C4.10756 0 2.57227 1.5278 2.57227 3.41244C2.57227 5.29708 4.10756 6.82488 6.00143 6.82488Z"
                      fill="#265D91"
                    />
                    <path
                      d="M7.71563 7.67798H4.28646C3.72355 7.67798 3.16616 7.78831 2.6461 8.00267C2.12604 8.21704 1.65351 8.53124 1.25547 8.92733C0.451608 9.72727 0 10.8122 0 11.9435V15.356C0 15.5822 0.0903215 15.7992 0.251095 15.9592C0.411868 16.1192 0.629924 16.2091 0.857292 16.2091H11.1448C11.3722 16.2091 11.5902 16.1192 11.751 15.9592C11.9118 15.7992 12.0021 15.5822 12.0021 15.356V11.9435C12.0021 10.8122 11.5505 9.72727 10.7466 8.92733C9.94274 8.12738 8.85246 7.67798 7.71563 7.67798Z"
                      fill="#265D91"
                    />
                    <path
                      d="M24.8616 6.82487H14.5741C14.3467 6.82487 14.1287 6.73499 13.9679 6.575C13.8071 6.41501 13.7168 6.19802 13.7168 5.97176C13.7168 5.7455 13.8071 5.52851 13.9679 5.36852C14.1287 5.20853 14.3467 5.11865 14.5741 5.11865H24.8616C25.089 5.11865 25.307 5.20853 25.4678 5.36852C25.6286 5.52851 25.7189 5.7455 25.7189 5.97176C25.7189 6.19802 25.6286 6.41501 25.4678 6.575C25.307 6.73499 25.089 6.82487 24.8616 6.82487Z"
                      fill="#265D91"
                    />
                    <path
                      d="M24.8616 10.2372H14.5741C14.3467 10.2372 14.1287 10.1473 13.9679 9.98736C13.8071 9.82737 13.7168 9.61037 13.7168 9.38412C13.7168 9.15786 13.8071 8.94086 13.9679 8.78088C14.1287 8.62089 14.3467 8.53101 14.5741 8.53101H24.8616C25.089 8.53101 25.307 8.62089 25.4678 8.78088C25.6286 8.94086 25.7189 9.15786 25.7189 9.38412C25.7189 9.61037 25.6286 9.82737 25.4678 9.98736C25.307 10.1473 25.089 10.2372 24.8616 10.2372Z"
                      fill="#265D91"
                    />
                    <path
                      d="M19.7178 13.6496H14.5741C14.3467 13.6496 14.1287 13.5597 13.9679 13.3997C13.8071 13.2397 13.7168 13.0227 13.7168 12.7965C13.7168 12.5702 13.8071 12.3532 13.9679 12.1932C14.1287 12.0332 14.3467 11.9434 14.5741 11.9434H19.7178C19.9452 11.9434 20.1633 12.0332 20.324 12.1932C20.4848 12.3532 20.5751 12.5702 20.5751 12.7965C20.5751 13.0227 20.4848 13.2397 20.324 13.3997C20.1633 13.5597 19.9452 13.6496 19.7178 13.6496Z"
                      fill="#265D91"
                    />
                  </svg>
                  Nom
                </div>
                <div class="text-gray-600">
                  {{ selectedCandidate?.first_name }}
                </div>
              </div>
              <!--begin::Details item-->
              <!--begin::Details item-->
              <div class="flex-space">
                <div class="contact-info-name">
                  <svg
                    width="26"
                    height="17"
                    viewBox="0 0 26 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.00143 6.82488C7.89531 6.82488 9.4306 5.29708 9.4306 3.41244C9.4306 1.5278 7.89531 0 6.00143 0C4.10756 0 2.57227 1.5278 2.57227 3.41244C2.57227 5.29708 4.10756 6.82488 6.00143 6.82488Z"
                      fill="#265D91"
                    />
                    <path
                      d="M7.71563 7.67798H4.28646C3.72355 7.67798 3.16616 7.78831 2.6461 8.00267C2.12604 8.21704 1.65351 8.53124 1.25547 8.92733C0.451608 9.72727 0 10.8122 0 11.9435V15.356C0 15.5822 0.0903215 15.7992 0.251095 15.9592C0.411868 16.1192 0.629924 16.2091 0.857292 16.2091H11.1448C11.3722 16.2091 11.5902 16.1192 11.751 15.9592C11.9118 15.7992 12.0021 15.5822 12.0021 15.356V11.9435C12.0021 10.8122 11.5505 9.72727 10.7466 8.92733C9.94274 8.12738 8.85246 7.67798 7.71563 7.67798Z"
                      fill="#265D91"
                    />
                    <path
                      d="M24.8616 6.82487H14.5741C14.3467 6.82487 14.1287 6.73499 13.9679 6.575C13.8071 6.41501 13.7168 6.19802 13.7168 5.97176C13.7168 5.7455 13.8071 5.52851 13.9679 5.36852C14.1287 5.20853 14.3467 5.11865 14.5741 5.11865H24.8616C25.089 5.11865 25.307 5.20853 25.4678 5.36852C25.6286 5.52851 25.7189 5.7455 25.7189 5.97176C25.7189 6.19802 25.6286 6.41501 25.4678 6.575C25.307 6.73499 25.089 6.82487 24.8616 6.82487Z"
                      fill="#265D91"
                    />
                    <path
                      d="M24.8616 10.2372H14.5741C14.3467 10.2372 14.1287 10.1473 13.9679 9.98736C13.8071 9.82737 13.7168 9.61037 13.7168 9.38412C13.7168 9.15786 13.8071 8.94086 13.9679 8.78088C14.1287 8.62089 14.3467 8.53101 14.5741 8.53101H24.8616C25.089 8.53101 25.307 8.62089 25.4678 8.78088C25.6286 8.94086 25.7189 9.15786 25.7189 9.38412C25.7189 9.61037 25.6286 9.82737 25.4678 9.98736C25.307 10.1473 25.089 10.2372 24.8616 10.2372Z"
                      fill="#265D91"
                    />
                    <path
                      d="M19.7178 13.6496H14.5741C14.3467 13.6496 14.1287 13.5597 13.9679 13.3997C13.8071 13.2397 13.7168 13.0227 13.7168 12.7965C13.7168 12.5702 13.8071 12.3532 13.9679 12.1932C14.1287 12.0332 14.3467 11.9434 14.5741 11.9434H19.7178C19.9452 11.9434 20.1633 12.0332 20.324 12.1932C20.4848 12.3532 20.5751 12.5702 20.5751 12.7965C20.5751 13.0227 20.4848 13.2397 20.324 13.3997C20.1633 13.5597 19.9452 13.6496 19.7178 13.6496Z"
                      fill="#265D91"
                    />
                  </svg>
                  Prénom
                </div>
                <div class="text-gray-600">
                 {{ selectedCandidate?.last_name }}
                </div>
              </div>
              <!--begin::Details item-->
              <!--begin::Details item-->
              <div class="flex-space">
                <div class="contact-info-name">
                  <svg
                    width="22"
                    height="15"
                    viewBox="0 0 22 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.22768 0.317383H19.773C20.3839 0.317383 20.941 0.567059 21.3459 0.97049C21.7501 1.37392 22 1.92829 22 2.53696V12.2962C22 12.907 21.7494 13.462 21.3459 13.8641L21.3247 13.8838C20.9219 14.2746 20.374 14.5158 19.7723 14.5158H2.22697C1.61537 14.5158 1.05827 14.2661 0.654783 13.8634C0.250587 13.462 0 12.907 0 12.2962V2.53696C0 1.92829 0.250587 1.37322 0.655491 0.969785C1.06039 0.567059 1.61678 0.318088 2.22768 0.318088V0.317383ZM2.67718 2.19489L2.29847 2.78946L11.0004 8.30419L19.7015 2.78946L19.3228 2.19489L10.9996 7.46912L2.67647 2.19489H2.67718Z"
                      fill="#265D91"
                    />
                  </svg>

                  Email
                </div>
                <div class="text-gray-600">{{ selectedCandidate?.email }}</div>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 22 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.22768 0.317383H19.773C20.3839 0.317383 20.941 0.567059 21.3459 0.97049C21.7501 1.37392 22 1.92829 22 2.53696V12.2962C22 12.907 21.7494 13.462 21.3459 13.8641L21.3247 13.8838C20.9219 14.2746 20.374 14.5158 19.7723 14.5158H2.22697C1.61537 14.5158 1.05827 14.2661 0.654783 13.8634C0.250587 13.462 0 12.907 0 12.2962V2.53696C0 1.92829 0.250587 1.37322 0.655491 0.969785C1.06039 0.567059 1.61678 0.318088 2.22768 0.318088V0.317383ZM2.67718 2.19489L2.29847 2.78946L11.0004 8.30419L19.7015 2.78946L19.3228 2.19489L10.9996 7.46912L2.67647 2.19489H2.67718Z"
                      fill="#265D91"
                    />
                  </svg>

                  Email Professionnel ESN
                </div>
                <div class="text-gray-600">
                  {{
                    selectedCandidate?.emailProESN
                      ? selectedCandidate?.emailProESN
                      : "---"
                  }}
                </div>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 22 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.22768 0.317383H19.773C20.3839 0.317383 20.941 0.567059 21.3459 0.97049C21.7501 1.37392 22 1.92829 22 2.53696V12.2962C22 12.907 21.7494 13.462 21.3459 13.8641L21.3247 13.8838C20.9219 14.2746 20.374 14.5158 19.7723 14.5158H2.22697C1.61537 14.5158 1.05827 14.2661 0.654783 13.8634C0.250587 13.462 0 12.907 0 12.2962V2.53696C0 1.92829 0.250587 1.37322 0.655491 0.969785C1.06039 0.567059 1.61678 0.318088 2.22768 0.318088V0.317383ZM2.67718 2.19489L2.29847 2.78946L11.0004 8.30419L19.7015 2.78946L19.3228 2.19489L10.9996 7.46912L2.67647 2.19489H2.67718Z"
                      fill="#265D91"
                    />
                  </svg>

                  Email Professionnel ESN
                </div>
                <div class="text-gray-600">
                  {{
                    selectedCandidate?.emailProESN
                      ? selectedCandidate?.emailProESN
                      : "---"
                  }}
                </div>
              </div>
              <!--begin::Details item-->
              <!--begin::Details item-->
              <div class="flex-space">
                <div class="contact-info-name">
                  <svg
                    width="16"
                    height="19"
                    viewBox="0 0 16 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.4765 15.2659C15.0935 14.106 14.4041 13.1154 13.4296 12.3235C13.0541 12.0166 12.6813 11.8364 12.2907 11.773C12.139 11.7484 11.9833 11.742 11.8277 11.7532C11.3119 11.793 10.7972 11.947 10.2547 12.2246C10.0838 12.3131 9.8872 12.3393 9.67121 12.3044C9.40779 12.2616 9.13791 12.1253 8.96659 11.9486C7.72269 10.6648 6.71735 9.27018 5.89276 7.68598C5.73111 7.3741 5.66457 6.74322 6.03852 6.37848C6.47511 5.95353 6.78481 5.51525 6.9863 5.03881C7.20252 4.52538 7.1917 3.97034 6.95291 3.3436C6.50942 2.16826 5.78707 1.20206 4.80682 0.470746C4.48928 0.233563 4.14941 0.0841746 3.79549 0.0264877C3.20463 -0.0695805 2.60962 0.0968151 2.07517 0.507059C1.58401 0.883517 1.13729 1.29422 0.617576 1.79479C0.141384 2.25306 0.0755277 2.86096 0.0170399 3.39669L0.015428 3.40795C-0.0460533 4.09031 0.0757578 4.92873 0.389151 5.97169C0.918995 7.73654 1.79654 9.47312 3.07337 11.2812C3.33565 11.653 4.3852 13.1085 4.65531 13.4749C5.96806 15.2572 7.33953 16.6399 8.84778 17.7007C9.73937 18.3284 10.4972 18.7102 11.1647 18.8683L11.176 18.8703C11.3137 18.9002 11.4613 18.9317 11.6059 18.9551C11.9626 19.0133 12.4305 19.0491 12.8887 18.8108C13.5296 18.4776 14.0617 18.185 14.5736 17.8405C15.4735 17.2372 15.8106 16.2744 15.4765 15.2659ZM3.82934 3.49391C3.14936 2.55092 2.94995 1.5337 3.384 1.22205C3.81806 0.910178 4.72116 1.42201 5.40114 2.36499C6.08112 3.30798 6.28053 4.3252 5.84671 4.63684C5.41242 4.94872 4.50932 4.43689 3.82934 3.49391ZM14.3991 16.5771C13.965 16.889 13.0619 16.3772 12.3819 15.4342C11.7019 14.4912 11.5025 13.474 11.9363 13.1623C12.3702 12.8507 13.2735 13.3623 13.9535 14.3053C14.6337 15.2482 14.8331 16.2655 14.3991 16.5771Z"
                      fill="#265D91"
                    />
                  </svg>

                  Téléphone
                </div>
                <div class="text-gray-600">
                  {{
                    selectedCandidate?.phone_number
                      ? selectedCandidate?.phone_number
                      : "---"
                  }}
                </div>
              </div>

              <div class="flex-space">
                <div class="contact-info-name">
                  <svg
                    width="22"
                    height="25"
                    viewBox="0 0 22 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 4.48615V0.996923H1V0.498462C1 0.224308 0.775 0 0.5 0C0.225 0 0 0.224308 0 0.498462V24.4246C0 24.6988 0.225 24.9231 0.5 24.9231C0.775 24.9231 1 24.6988 1 24.4246V10.9662H5.5H11V4.48615ZM3.855 6.83391C3.76 6.92862 3.635 6.97846 3.5 6.97846C3.365 6.97846 3.24 6.92363 3.145 6.83391C3.05 6.7392 3 6.61458 3 6.48C3 6.34542 3.055 6.2208 3.145 6.12609C3.235 6.03138 3.365 5.98154 3.5 5.98154C3.635 5.98154 3.76 6.03637 3.855 6.12609C3.95 6.21582 4 6.34542 4 6.48C4 6.61458 3.945 6.7392 3.855 6.83391ZM3.855 3.84314C3.76 3.93785 3.635 3.98769 3.5 3.98769C3.365 3.98769 3.24 3.93286 3.145 3.84314C3.05 3.75342 3 3.61883 3 3.48923C3 3.35963 3.055 3.23003 3.145 3.13532C3.235 3.04062 3.365 2.99077 3.5 2.99077C3.635 2.99077 3.76 3.0456 3.855 3.13532C3.95 3.22505 4 3.35465 4 3.48923C4 3.62382 3.945 3.74843 3.855 3.84314Z"
                      fill="#265D91"
                    />
                    <path d="M6 11.9629V14.52L9.85 11.9629H6Z" fill="#265D91" />
                    <path
                      d="M12.0004 4.98486V11.4649V11.4698C12.0004 11.4848 12.0004 11.4948 12.0004 11.5097C12.0004 11.5147 12.0004 11.5147 12.0004 11.5147C12.0004 11.5297 11.9954 11.5446 11.9954 11.5596C11.9954 11.5646 11.9904 11.5695 11.9904 11.5745C11.9904 11.5845 11.9854 11.5895 11.9854 11.5994C11.9854 11.6044 11.9804 11.6144 11.9804 11.6194C11.9754 11.6294 11.9754 11.6343 11.9704 11.6443C11.9654 11.6493 11.9654 11.6593 11.9604 11.6642C11.9554 11.6742 11.9504 11.6792 11.9504 11.6892C11.9504 11.6942 11.9454 11.6991 11.9454 11.7041C11.9404 11.7191 11.9304 11.729 11.9254 11.739C11.9254 11.744 11.9204 11.744 11.9154 11.749C11.9104 11.759 11.9054 11.7639 11.8954 11.7739C11.8904 11.7789 11.8904 11.7839 11.8854 11.7839C11.8804 11.7938 11.8704 11.7988 11.8654 11.8038C11.8604 11.8088 11.8604 11.8088 11.8554 11.8138C11.8504 11.8188 11.8404 11.8287 11.8354 11.8337C11.8304 11.8387 11.8254 11.8387 11.8254 11.8437C11.8154 11.8487 11.8104 11.8586 11.8004 11.8636C11.7954 11.8686 11.7954 11.8686 11.7904 11.8736L7.15039 14.9541H22.0004V4.98486H12.0004ZM19.8554 12.8157C19.7604 12.9104 19.6354 12.9602 19.5004 12.9602C19.3654 12.9602 19.2404 12.9054 19.1454 12.8157C19.0504 12.721 19.0004 12.5964 19.0004 12.4618C19.0004 12.3272 19.0554 12.2026 19.1454 12.1079C19.2404 12.0132 19.3654 11.9633 19.5004 11.9633C19.6354 11.9633 19.7604 12.0182 19.8554 12.1079C19.9504 12.2026 20.0004 12.3272 20.0004 12.4618C20.0004 12.5964 19.9454 12.721 19.8554 12.8157ZM19.8554 9.82492C19.7604 9.91963 19.6354 9.96948 19.5004 9.96948C19.3654 9.96948 19.2404 9.91465 19.1454 9.82492C19.0504 9.7352 19.0004 9.6056 19.0004 9.47102C19.0004 9.33643 19.0554 9.21182 19.1454 9.11711C19.2404 9.0224 19.3654 8.97256 19.5004 8.97256C19.6354 8.97256 19.7604 9.02739 19.8554 9.11711C19.9504 9.21182 20.0004 9.33643 20.0004 9.47102C20.0004 9.6056 19.9454 9.73022 19.8554 9.82492Z"
                      fill="#265D91"
                    />
                  </svg>

                  Pays de résidence actuel
                </div>
                <div class="text-gray-600">
                  {{ selectedCandidate?.current_country }}
                </div>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">
                  <svg
                    width="22"
                    height="25"
                    viewBox="0 0 22 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 4.48615V0.996923H1V0.498462C1 0.224308 0.775 0 0.5 0C0.225 0 0 0.224308 0 0.498462V24.4246C0 24.6988 0.225 24.9231 0.5 24.9231C0.775 24.9231 1 24.6988 1 24.4246V10.9662H5.5H11V4.48615ZM3.855 6.83391C3.76 6.92862 3.635 6.97846 3.5 6.97846C3.365 6.97846 3.24 6.92363 3.145 6.83391C3.05 6.7392 3 6.61458 3 6.48C3 6.34542 3.055 6.2208 3.145 6.12609C3.235 6.03138 3.365 5.98154 3.5 5.98154C3.635 5.98154 3.76 6.03637 3.855 6.12609C3.95 6.21582 4 6.34542 4 6.48C4 6.61458 3.945 6.7392 3.855 6.83391ZM3.855 3.84314C3.76 3.93785 3.635 3.98769 3.5 3.98769C3.365 3.98769 3.24 3.93286 3.145 3.84314C3.05 3.75342 3 3.61883 3 3.48923C3 3.35963 3.055 3.23003 3.145 3.13532C3.235 3.04062 3.365 2.99077 3.5 2.99077C3.635 2.99077 3.76 3.0456 3.855 3.13532C3.95 3.22505 4 3.35465 4 3.48923C4 3.62382 3.945 3.74843 3.855 3.84314Z"
                      fill="#265D91"
                    />
                    <path d="M6 11.9629V14.52L9.85 11.9629H6Z" fill="#265D91" />
                    <path
                      d="M12.0004 4.98486V11.4649V11.4698C12.0004 11.4848 12.0004 11.4948 12.0004 11.5097C12.0004 11.5147 12.0004 11.5147 12.0004 11.5147C12.0004 11.5297 11.9954 11.5446 11.9954 11.5596C11.9954 11.5646 11.9904 11.5695 11.9904 11.5745C11.9904 11.5845 11.9854 11.5895 11.9854 11.5994C11.9854 11.6044 11.9804 11.6144 11.9804 11.6194C11.9754 11.6294 11.9754 11.6343 11.9704 11.6443C11.9654 11.6493 11.9654 11.6593 11.9604 11.6642C11.9554 11.6742 11.9504 11.6792 11.9504 11.6892C11.9504 11.6942 11.9454 11.6991 11.9454 11.7041C11.9404 11.7191 11.9304 11.729 11.9254 11.739C11.9254 11.744 11.9204 11.744 11.9154 11.749C11.9104 11.759 11.9054 11.7639 11.8954 11.7739C11.8904 11.7789 11.8904 11.7839 11.8854 11.7839C11.8804 11.7938 11.8704 11.7988 11.8654 11.8038C11.8604 11.8088 11.8604 11.8088 11.8554 11.8138C11.8504 11.8188 11.8404 11.8287 11.8354 11.8337C11.8304 11.8387 11.8254 11.8387 11.8254 11.8437C11.8154 11.8487 11.8104 11.8586 11.8004 11.8636C11.7954 11.8686 11.7954 11.8686 11.7904 11.8736L7.15039 14.9541H22.0004V4.98486H12.0004ZM19.8554 12.8157C19.7604 12.9104 19.6354 12.9602 19.5004 12.9602C19.3654 12.9602 19.2404 12.9054 19.1454 12.8157C19.0504 12.721 19.0004 12.5964 19.0004 12.4618C19.0004 12.3272 19.0554 12.2026 19.1454 12.1079C19.2404 12.0132 19.3654 11.9633 19.5004 11.9633C19.6354 11.9633 19.7604 12.0182 19.8554 12.1079C19.9504 12.2026 20.0004 12.3272 20.0004 12.4618C20.0004 12.5964 19.9454 12.721 19.8554 12.8157ZM19.8554 9.82492C19.7604 9.91963 19.6354 9.96948 19.5004 9.96948C19.3654 9.96948 19.2404 9.91465 19.1454 9.82492C19.0504 9.7352 19.0004 9.6056 19.0004 9.47102C19.0004 9.33643 19.0554 9.21182 19.1454 9.11711C19.2404 9.0224 19.3654 8.97256 19.5004 8.97256C19.6354 8.97256 19.7604 9.02739 19.8554 9.11711C19.9504 9.21182 20.0004 9.33643 20.0004 9.47102C20.0004 9.6056 19.9454 9.73022 19.8554 9.82492Z"
                      fill="#265D91"
                    />
                  </svg>

                  Pays destinaire
                </div>
                <div class="text-gray-600">
                  {{ selectedCandidate?.destination_country }}
                </div>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">
                  <svg
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.78122 2.03781C8.78122 2.03781 8.78122 2.03781 8.78122 2.03781L7.66067 3.16667H13.9375C14.304 3.16667 14.6 3.46584 14.6 3.83334C14.6 4.20083 14.304 4.5 13.9375 4.5H7.66067L8.78122 5.62886C9.0396 5.88915 9.0396 6.31086 8.78122 6.57114M8.78122 2.03781L7.91476 1.16598L7.84379 1.09553L7.84379 1.09553L5.59379 3.3622C5.59379 3.3622 5.59379 3.3622 5.59379 3.3622C5.3354 3.62248 5.3354 4.04419 5.59379 4.30448C5.59379 4.30448 5.59379 4.30448 5.59379 4.30448L7.84379 6.57114C8.10256 6.83185 8.52244 6.83185 8.78122 6.57114M8.78122 2.03781C9.0396 1.77752 9.0396 1.35581 8.78122 1.09553L8.78122 2.03781ZM8.78122 6.57114L8.71025 6.50069L8.78122 6.57114C8.78122 6.57114 8.78122 6.57114 8.78122 6.57114Z"
                      fill="#265D91"
                      stroke="#265D91"
                      stroke-width="0.2"
                    />
                    <path
                      d="M17.7813 6.76252L17.7813 6.76252C17.5224 6.50182 17.1026 6.50182 16.8437 6.76252L16.8437 6.76253C16.5854 7.02282 16.5854 7.44451 16.8437 7.70479L16.8437 7.7048L20.2143 11.1003H1.5625C1.19591 11.1003 0.9 11.3996 0.9 11.767C0.9 12.1344 1.19591 12.4337 1.5625 12.4337H20.2143L16.8437 15.8291L16.8437 15.8292C16.5854 16.0895 16.5854 16.5112 16.8437 16.7715L16.8437 16.7715C17.1026 17.0321 17.5224 17.0321 17.7813 16.7715L17.7813 16.7715L22.2813 12.2382L22.2813 12.2382C22.5396 11.9778 22.5396 11.5561 22.2813 11.2958L22.2813 11.2958L17.7813 6.76252Z"
                      fill="#265D91"
                      stroke="#265D91"
                      stroke-width="0.2"
                    />
                    <path
                      d="M8.78122 21.4955L8.78122 21.4955L7.66067 20.3667H13.9375C14.304 20.3667 14.6 20.0675 14.6 19.7C14.6 19.3326 14.304 19.0334 13.9375 19.0334H7.66067L8.78122 17.9046L8.78122 17.9046C9.0396 17.6442 9.0396 17.2225 8.78122 16.9622L8.78121 16.9622C8.52243 16.7015 8.10258 16.7015 7.8438 16.9622L7.84379 16.9622L5.59379 19.2288L5.59378 19.2288C5.33541 19.4892 5.33541 19.9109 5.59378 20.1712L5.59379 20.1712L7.84379 22.4379L7.8438 22.4379C8.10258 22.6985 8.52243 22.6985 8.78121 22.4379L8.78122 22.4379C9.0396 22.1776 9.0396 21.7558 8.78122 21.4955Z"
                      fill="#265D91"
                      stroke="#265D91"
                      stroke-width="0.2"
                    /></svg
                  >Mobilité
                </div>
                <div
                  *ngFor="let item of selectedCandidate?.mobility"
                  class="text-gray-600"
                >
                  {{ item }}
                </div>
              </div>

              <div class="flex-space">
                <div class="contact-info-name">
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g filter="url(#filter0_d_444_1768)">
                      <path
                        d="M16.0442 6.79683H23.9584V8.36302H25.1979V5.71521H14.8047V8.36302H16.0442V6.79683Z"
                        fill="#265D91"
                      />
                      <path
                        d="M31.989 16.1651C32.4197 15.9199 32.7979 15.6546 33.1092 15.3748V10.3503C33.1092 9.72439 32.5971 9.21387 31.9628 9.21387H8.03994C7.40565 9.21387 6.89355 9.72439 6.89355 10.3503V15.3748C7.20488 15.6546 7.58313 15.9199 8.01376 16.1651C10.2804 17.4428 14.0599 18.1697 18.0519 18.3485V16.9323C18.0519 15.9084 18.8899 15.0806 19.9199 15.0806H20.08C21.1129 15.0806 21.9479 15.9113 21.9479 16.9323V18.3485C25.9428 18.1697 29.7224 17.4428 31.989 16.1651Z"
                        fill="#265D91"
                      />
                      <path
                        d="M19.9198 15.9286C19.364 15.9286 18.9072 16.3814 18.9072 16.9323V19.8426C18.9072 20.3935 19.364 20.8464 19.9198 20.8464H20.0798C20.6355 20.8464 21.0924 20.3935 21.0924 19.8426V16.9323C21.0924 16.3814 20.6355 15.9286 20.0798 15.9286H19.9198Z"
                        fill="#265D91"
                      />
                      <path
                        d="M30.6681 7.05065L33.8221 3.92405L32.0472 2.16461L28.8932 5.29121L27.7119 4.12306V8.22168H31.8465L30.6681 7.05065Z"
                        fill="#265D91"
                      />
                      <path
                        d="M29.4575 3.65587C29.5303 3.65587 29.603 3.62703 29.6583 3.57223L32.7745 0.483123C32.8851 0.373519 32.8851 0.191807 32.7745 0.0822031C32.6639 -0.027401 32.4806 -0.027401 32.37 0.0822031L29.2568 3.17419C29.1462 3.2838 29.1462 3.46551 29.2568 3.57511C29.312 3.62991 29.3848 3.65587 29.4575 3.65587Z"
                        fill="#265D91"
                      />
                      <path
                        d="M33.6098 2.78188C33.6826 2.78188 33.7553 2.75303 33.8106 2.69823L35.3672 1.15512C35.4778 1.04552 35.4778 0.863804 35.3672 0.7542C35.2567 0.644596 35.0734 0.644596 34.9628 0.7542L33.4062 2.29731C33.2956 2.40691 33.2956 2.58863 33.4062 2.69823C33.4644 2.75592 33.5371 2.78188 33.6098 2.78188Z"
                        fill="#265D91"
                      />
                      <path
                        d="M32.3993 6.69015C32.4546 6.74495 32.5274 6.77379 32.6001 6.77379C32.6728 6.77379 32.7456 6.74495 32.8009 6.69015L35.9171 3.60104C36.0276 3.49144 36.0276 3.30973 35.9171 3.20012C35.8065 3.09052 35.6232 3.09052 35.5126 3.20012L32.3993 6.28923C32.2888 6.40172 32.2888 6.58054 32.3993 6.69015Z"
                        fill="#265D91"
                      />
                      <path
                        d="M9.33567 24.6797L6.18164 27.8063L7.95651 29.5657L11.1105 26.4391L12.2918 27.6073V23.5087H8.15727L9.33567 24.6797Z"
                        fill="#265D91"
                      />
                      <path
                        d="M10.3407 28.1553L7.22746 31.2444C7.11689 31.354 7.11689 31.5357 7.22746 31.6453C7.28274 31.7001 7.35548 31.7289 7.42822 31.7289C7.50096 31.7289 7.5737 31.7001 7.62898 31.6453L10.7452 28.5562C10.8558 28.4466 10.8558 28.2649 10.7452 28.1553C10.6346 28.0457 10.4542 28.0457 10.3407 28.1553Z"
                        fill="#265D91"
                      />
                      <path
                        d="M6.19229 29.0292L4.63273 30.5752C4.52216 30.6848 4.52216 30.8665 4.63273 30.9761C4.68801 31.0309 4.76075 31.0597 4.83349 31.0597C4.90623 31.0597 4.97897 31.0309 5.03426 30.9761L6.5909 29.433C6.70147 29.3234 6.70147 29.1417 6.5909 29.0321C6.48325 28.9196 6.30285 28.9196 6.19229 29.0292Z"
                        fill="#265D91"
                      />
                      <path
                        d="M7.60356 25.0402C7.493 24.9306 7.30969 24.9306 7.19913 25.0402L4.08292 28.1293C3.97236 28.2389 3.97236 28.4206 4.08292 28.5302C4.13821 28.585 4.21095 28.6139 4.28369 28.6139C4.35643 28.6139 4.42917 28.585 4.48445 28.5302L7.60356 25.4411C7.71413 25.3286 7.71413 25.1498 7.60356 25.0402Z"
                        fill="#265D91"
                      />
                      <path
                        d="M6.18164 3.92405L9.33567 7.05065L8.15727 8.22168H12.2918V4.12306L11.1105 5.29121L7.95651 2.16461L6.18164 3.92405Z"
                        fill="#265D91"
                      />
                      <path
                        d="M7.19913 6.69013C7.25441 6.74494 7.32715 6.77378 7.39989 6.77378C7.47263 6.77378 7.54537 6.74494 7.60065 6.69013C7.71122 6.58053 7.71122 6.39882 7.60065 6.28921L4.48736 3.20299C4.3768 3.09339 4.19349 3.09339 4.08292 3.20299C3.97236 3.3126 3.97236 3.49431 4.08292 3.60391L7.19913 6.69013Z"
                        fill="#265D91"
                      />
                      <path
                        d="M6.31826 2.57709C6.37354 2.63189 6.44629 2.66074 6.51903 2.66074C6.59177 2.66074 6.66451 2.63189 6.71979 2.57709C6.83036 2.46749 6.83036 2.28578 6.71979 2.17617L5.16314 0.630177C5.05258 0.520573 4.86927 0.520573 4.75871 0.630177C4.64814 0.739781 4.64814 0.921493 4.75871 1.0311L6.31826 2.57709Z"
                        fill="#265D91"
                      />
                      <path
                        d="M10.3407 3.57516C10.396 3.62996 10.4688 3.6588 10.5415 3.6588C10.6142 3.6588 10.687 3.62996 10.7423 3.57516C10.8528 3.46555 10.8528 3.28384 10.7423 3.17424L7.62896 0.0851328C7.5184 -0.0244713 7.33509 -0.0244713 7.22453 0.0851328C7.11396 0.194737 7.11396 0.376449 7.22453 0.486053L10.3407 3.57516Z"
                        fill="#265D91"
                      />
                      <path
                        d="M33.8221 27.8063L30.6681 24.6797L31.8465 23.5087H27.7119V27.6073L28.8932 26.4391L32.0472 29.5657L33.8221 27.8063Z"
                        fill="#265D91"
                      />
                      <path
                        d="M32.8038 25.0402C32.6932 24.9306 32.5099 24.9306 32.3993 25.0402C32.2888 25.1498 32.2888 25.3315 32.3993 25.4411L35.5155 28.5302C35.5708 28.585 35.6436 28.6139 35.7163 28.6139C35.789 28.6139 35.8618 28.585 35.9171 28.5302C36.0276 28.4206 36.0276 28.2389 35.9171 28.1293L32.8038 25.0402Z"
                        fill="#265D91"
                      />
                      <path
                        d="M33.6846 29.1532C33.5741 29.0436 33.3908 29.0436 33.2802 29.1532C33.1696 29.2628 33.1696 29.4445 33.2802 29.5541L34.8368 31.0972C34.8921 31.152 34.9649 31.1809 35.0376 31.1809C35.1103 31.1809 35.1831 31.152 35.2384 31.0972C35.3489 30.9876 35.3489 30.8059 35.2384 30.6963L33.6846 29.1532Z"
                        fill="#265D91"
                      />
                      <path
                        d="M29.6612 28.1553C29.5506 28.0457 29.3673 28.0457 29.2568 28.1553C29.1462 28.2649 29.1462 28.4466 29.2568 28.5562L32.373 31.6453C32.4282 31.7001 32.501 31.7289 32.5737 31.7289C32.6465 31.7289 32.7192 31.7001 32.7745 31.6453C32.8851 31.5357 32.8851 31.354 32.7745 31.2444L29.6612 28.1553Z"
                        fill="#265D91"
                      />
                      <path
                        d="M31.9899 17.1256C29.6884 18.2765 26.066 19.0206 21.9517 19.1994V19.8426C21.9517 20.8666 21.1138 21.6973 20.0838 21.6973H19.9237C18.8908 21.6973 18.0558 20.8637 18.0558 19.8426V19.1994C13.9387 19.0206 10.3162 18.2765 8.01758 17.1256V22.6606H13.1501V26.0151H26.8574V22.6606H31.9899V17.1256Z"
                        fill="#265D91"
                      />
                    </g>
                    <defs>
                      <filter
                        id="filter0_d_444_1768"
                        x="0"
                        y="0"
                        width="40"
                        height="39.7289"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                      >
                        <feFlood
                          flood-opacity="0"
                          result="BackgroundImageFix"
                        />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_444_1768"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_444_1768"
                          result="shape"
                        />
                      </filter>
                    </defs>
                  </svg>
                  Ouvert pour une nouvelle mission
                </div>
                <div class="text-gray-600">
                  {{ selectedCandidate?.open_for_mission ? "Oui" : "Non" }}
                </div>
              </div>

              <!--begin::Details item-->
            </div>

            <div class="py-3 text-center title-bg">
              <div class="contact">Diplômes</div>

              <!--begin::Badge-->

              <!--begin::Badge-->
            </div>
            <!--end::Details toggle-->
            <div class="contact-info pb-5 pt-5 fs-6">
              <!--begin::Details item-->
              <div class="flex-space">
                <div class="contact-info-name">
                  <svg
                    width="29"
                    height="17"
                    viewBox="0 0 29 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.75164 10.5366L2.29932 11.457C2.05827 10.8591 1.77897 9.63482 1.77897 7.99566C1.77897 6.35649 2.05827 5.13223 2.29932 4.53431L7.30356 5.24861C7.41208 4.97231 7.56329 4.71377 7.75809 4.48811C7.69849 4.16738 7.70027 3.83955 7.75809 3.51883L1.77897 2.66504C0.796978 2.66504 0 5.05227 0 7.99566C0 10.939 0.796978 13.3263 1.77897 13.3263L10.2985 12.1109C9.92665 11.7999 9.64557 11.3957 9.48724 10.9408C9.21951 10.8466 8.97401 10.7072 8.75164 10.5366Z"
                      fill="#265D91"
                    />
                    <path
                      d="M26.6844 2.66504L20.7044 3.51794C20.7622 3.83777 20.7649 4.16561 20.7044 4.48722C20.8992 4.71377 21.0504 4.97231 21.159 5.24772L26.1641 4.53342C26.4051 5.13223 26.6844 6.35649 26.6844 7.99566C26.6844 9.63482 26.4051 10.8591 26.1641 11.457L19.7109 10.5366C19.4885 10.7054 19.243 10.8458 18.9753 10.939C18.8169 11.3948 18.5368 11.7999 18.1641 12.11L26.6844 13.3263C27.6664 13.3263 28.4634 10.939 28.4634 7.99566C28.4634 5.05227 27.6664 2.66504 26.6844 2.66504Z"
                      fill="#265D91"
                    />
                    <path
                      d="M19.6242 9.32858C19.9275 8.80351 19.9311 8.18961 19.6892 7.68053C20.1535 7.35892 20.4586 6.82586 20.4586 6.21905C20.4586 5.61314 20.1535 5.07919 19.69 4.75846C19.9311 4.24939 19.9284 3.6337 19.6251 3.10953C19.3209 2.58535 18.7908 2.27617 18.2286 2.22909C18.1824 1.66671 17.8728 1.1372 17.3471 0.833353C16.8206 0.529508 16.205 0.526843 15.6954 0.768497C15.3725 0.304734 14.8388 0 14.2313 0C13.6246 0 13.0901 0.304734 12.769 0.767609C12.2584 0.526843 11.6429 0.52862 11.1181 0.832465C10.5933 1.13631 10.2829 1.66582 10.2366 2.22731C9.67356 2.2744 9.14253 2.58446 8.83922 3.10953C8.53591 3.63459 8.53235 4.24939 8.7734 4.75846C8.30998 5.07919 8.00488 5.61314 8.00488 6.21905C8.00488 6.82586 8.30998 7.35892 8.77429 7.68053C8.53324 8.18961 8.53679 8.80351 8.84011 9.32858C9.14342 9.85276 9.67445 10.1513 10.2348 10.1984C10.2775 10.7643 10.5897 11.3 11.119 11.6056C11.2613 11.6883 11.4116 11.7469 11.5637 11.786V16.1225C11.5637 16.2495 11.6402 16.3632 11.7585 16.4121C11.8759 16.4609 12.0102 16.4343 12.101 16.3446L14.2322 14.215L16.3634 16.3437C16.4541 16.4343 16.5884 16.4601 16.7058 16.4112C16.8241 16.3632 16.9006 16.2486 16.9006 16.1216V11.7851C17.0527 11.746 17.2022 11.6874 17.3445 11.6048C17.8746 11.2991 18.1859 10.7634 18.2286 10.1975C18.7899 10.1513 19.3209 9.85276 19.6242 9.32858ZM14.2322 8.88436C12.7592 8.88436 11.5637 7.6903 11.5637 6.21905C11.5637 4.7478 12.7592 3.55374 14.2322 3.55374C15.7052 3.55374 16.9006 4.7478 16.9006 6.21905C16.9006 7.6903 15.7052 8.88436 14.2322 8.88436Z"
                      fill="#265D91"
                    />
                  </svg>

                  Diplomes
                </div>
                <div
                  *ngFor="let item of selectedCandidate?.diplomas"
                  class="text-gray-600"
                >
                  {{ item }}
                </div>
              </div>
            </div>

            <div class="py-3 text-center title-bg">
              <div class="contact">Certifications</div>
              <!--begin::Badge-->

              <!--begin::Badge-->
            </div>
            <!--end::Details toggle-->
            <div class="contact-info pb-5 fs-6">
              <!--begin::Details item-->
              <div class="certif">
                <div class="contact-info-name mb-5 mt-4">
                  <svg
                    width="31"
                    height="31"
                    viewBox="0 0 31 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g filter="url(#filter0_d_126_464)">
                      <path
                        d="M8.45028 5.11335H19.1868C19.5636 5.11335 19.8461 4.80842 19.8461 4.45658C19.8461 4.08128 19.54 3.7998 19.1868 3.7998H8.45028C8.07356 3.7998 7.79102 4.10474 7.79102 4.45658C7.79102 4.80842 8.07356 5.11335 8.45028 5.11335Z"
                        fill="#265D91"
                      />
                      <path
                        d="M8.45028 8.88972H19.1868C19.5636 8.88972 19.8461 8.58479 19.8461 8.23295C19.8461 7.8811 19.54 7.57617 19.1868 7.57617H8.45028C8.07356 7.57617 7.79102 7.8811 7.79102 8.23295C7.79102 8.58479 8.07356 8.88972 8.45028 8.88972Z"
                        fill="#265D91"
                      />
                      <path
                        d="M25.944 19.7971L24.2252 16.1614C24.5313 15.5984 24.6961 14.9416 24.6961 14.2614C24.6961 13.2059 24.2959 12.2442 23.6366 11.517V2.01724C23.6366 0.914793 22.7183 0 21.6117 0H6.02488C4.89471 0 4 0.914793 4 2.01724V14.4725C4 15.5984 4.91826 16.4897 6.02488 16.4897H16.8321L15.2781 19.7971C15.1133 20.1255 15.1604 20.5242 15.3958 20.8291C15.6313 21.1341 16.008 21.2514 16.3612 21.2044L17.2088 21.0402L17.6326 21.7908C17.7974 22.0958 18.1271 22.2834 18.5038 22.2834H18.5273C18.904 22.2834 19.2337 22.0489 19.3985 21.7205L20.6464 19.0934L21.8472 21.7205C22.012 22.0489 22.3416 22.2834 22.7183 22.2834H22.7654C23.1186 22.2834 23.4482 22.0958 23.6366 21.7908L24.0369 21.0402L24.8845 21.2044C25.2612 21.2748 25.6144 21.1341 25.8498 20.8291C26.0618 20.5242 26.1088 20.1255 25.944 19.7971ZM20.5993 17.0058C19.0924 17.0058 17.8445 15.7626 17.8445 14.2379C17.8445 12.7133 19.0924 11.4701 20.6228 11.4701C22.1533 11.4701 23.4012 12.7133 23.4012 14.2379C23.3776 15.7626 22.1297 17.0058 20.5993 17.0058ZM5.31853 14.4725V2.01724C5.31853 1.64194 5.64816 1.31355 6.02488 1.31355H21.6117C21.9885 1.31355 22.3181 1.61848 22.3181 2.01724V10.5319C21.8001 10.2973 21.2115 10.1566 20.5993 10.1566C19.4691 10.1566 18.4331 10.6257 17.6797 11.3763H8.45002C8.0733 11.3763 7.79076 11.6812 7.79076 12.0331C7.79076 12.3849 8.09685 12.6898 8.45002 12.6898H16.8321C16.6437 13.1589 16.526 13.6984 16.526 14.2379C16.526 14.5663 16.5731 14.8713 16.6437 15.1527H6.04842C5.64816 15.1762 5.31853 14.8478 5.31853 14.4725ZM18.4567 20.5711L18.2448 20.1958C18.08 19.8674 17.7268 19.6798 17.3736 19.6798C17.303 19.6798 17.2559 19.6798 17.1853 19.7032L16.7614 19.7736L17.9151 17.3107C18.3861 17.7329 18.9511 18.0144 19.5633 18.1786L18.4567 20.5711ZM24.0369 19.7032C23.6131 19.6329 23.1893 19.8205 22.9773 20.1958L22.7654 20.5711L21.6588 18.1786C22.271 18.0144 22.8361 17.7095 23.307 17.2872L24.4607 19.7502L24.0369 19.7032Z"
                        fill="#265D91"
                      />
                    </g>
                    <defs>
                      <filter
                        id="filter0_d_126_464"
                        x="0"
                        y="0"
                        width="30.043"
                        height="30.2832"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                      >
                        <feFlood
                          flood-opacity="0"
                          result="BackgroundImageFix"
                        />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_126_464"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_126_464"
                          result="shape"
                        />
                      </filter>
                    </defs>
                  </svg>

                  Certification
                </div>
                <div
                  *ngFor="let item of selectedCandidate?.certificates"
                  class="text-gray-600"
                >
                  {{ item }}
                </div>
              </div>
            </div>
            <!--end::Details content-->
          </div>
          <!--end::Card body-->
        </div>
        <!--end::Card-->
      </div>
      <!--end::Sidebar-->
      <!--begin::Content-->
      <div class="flex-lg-row-fluid">
        <!--begin:::Tabs-->
        <div class="card card-right pt-4 mb-6 mb-xl-9">
          <!--begin::Card header-->
          <div class="card-header border-0">
            <!--begin::Card title-->
            <div class="card-title flex-column">
              <h2 class="mb-1">
                <svg
                  width="34"
                  height="40"
                  viewBox="0 0 34 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_126_200)">
                    <mask
                      id="mask0_126_200"
                      style="mask-type: luminance"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="34"
                      height="34"
                    >
                      <path d="M33.1272 0H0V33.2H33.1272V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask0_126_200)">
                      <path
                        d="M12.423 2.07499C11.131 2.07499 10.1477 2.07046 9.3194 2.16415C8.49111 2.25783 7.73291 2.46482 7.16602 3.03346C6.59921 3.60209 6.39364 4.36177 6.30064 5.19156C6.2078 6.01983 6.21166 7.00397 6.21167 8.29389C6.21167 8.29457 6.21167 8.29524 6.21167 8.29592V8.29997V20.7541C6.21148 23.1225 6.0608 24.5238 6.90722 25.7106C7.33069 26.3044 8.01481 26.6431 8.71679 26.7906C9.20428 26.893 9.76589 26.927 10.3808 26.9466C10.3936 27.3216 10.4054 27.6905 10.4415 28.0105C10.535 28.8407 10.7414 29.6025 11.3089 30.1706C11.8763 30.7386 12.6344 30.9427 13.4622 31.0358C14.2901 31.1289 15.2734 31.125 16.5639 31.125H22.7025C22.7267 31.1265 22.751 31.1272 22.7752 31.127C24.0658 31.127 25.049 31.1311 25.8769 31.0378C26.7047 30.9446 27.4628 30.7386 28.0303 30.1706C28.5976 29.6025 28.8042 28.8427 28.8977 28.0125C28.9911 27.1828 28.9866 26.1957 28.9866 24.902V12.45C28.9869 12.4046 28.9842 12.3592 28.9785 12.3142C28.9784 11.5259 28.9721 10.8971 28.653 10.2574C28.3144 9.57859 27.8098 9.11651 26.9546 8.25943C26.0993 7.40172 25.6447 6.89802 24.9671 6.55731C24.8557 6.50129 24.7446 6.46636 24.6335 6.42762C24.5207 6.11863 24.3632 5.81855 24.1603 5.55223C23.8329 5.12229 23.4209 4.71792 22.8137 4.10948C21.9584 3.25177 21.5038 2.74808 20.8262 2.40736C20.1696 2.07726 19.5284 2.0769 18.7032 2.07706C18.6789 2.07553 18.6546 2.07486 18.6304 2.07504L12.423 2.07499ZM12.423 4.14999H17.5991V6.22499H16.5639C15.2719 6.22499 14.2886 6.22046 13.4603 6.31415C12.632 6.40783 11.8738 6.61482 11.3069 7.18346C10.7401 7.75209 10.5345 8.51177 10.4415 9.34156C10.3487 10.1698 10.3526 11.154 10.3526 12.4439C10.3526 12.4446 10.3526 12.4452 10.3526 12.4459V12.45V24.8699C9.84479 24.8488 9.41116 24.8171 9.14146 24.7605C8.72636 24.6733 8.66662 24.6084 8.5915 24.5031C8.44136 24.2926 8.28235 23.1205 8.28214 20.7543V8.29601C8.28216 7.00577 8.28869 6.04972 8.35898 5.42265C8.42935 4.79485 8.54842 4.5824 8.62992 4.50066C8.7114 4.41891 8.92543 4.29795 9.55191 4.2271C10.1784 4.15624 11.1321 4.14999 12.423 4.14999ZM19.6696 4.20672C19.7466 4.22271 19.8398 4.23318 19.896 4.26144C20.0856 4.35673 20.4949 4.71725 21.3498 5.5745C21.3498 5.57517 21.3498 5.57585 21.3498 5.57652C21.6681 5.89554 21.7638 6.01705 21.9604 6.22496H19.6696L19.6696 4.20672ZM16.5639 8.29997H21.74V12.45C21.7401 13.0229 22.2035 13.4874 22.7752 13.4875H26.9161V24.902V24.9041C26.9161 26.1967 26.91 27.152 26.8393 27.7795C26.7686 28.4074 26.6479 28.6198 26.5664 28.7015C26.4848 28.7832 26.2728 28.9045 25.6464 28.9751C25.0327 29.0441 24.0941 29.0518 22.844 29.0521C22.8198 29.0505 22.7955 29.0499 22.7712 29.05H16.5639C15.2741 29.05 14.3193 29.0455 13.6928 28.9751C13.0664 28.9046 12.8544 28.7831 12.7729 28.7015C12.6914 28.6199 12.5706 28.4074 12.4999 27.7795C12.4293 27.1524 12.4231 26.1958 12.4231 24.9041V12.4499V12.4459C12.4231 11.1556 12.4296 10.1996 12.4999 9.57252C12.5703 8.94471 12.6894 8.73226 12.7708 8.65052C12.8523 8.56877 13.0664 8.44781 13.6928 8.37696C14.3193 8.30611 15.273 8.29997 16.5639 8.29997ZM23.8105 8.35671C23.8875 8.37269 23.9807 8.38317 24.0369 8.41142C24.2265 8.50672 24.6358 8.86724 25.4907 9.72448C25.4907 9.72516 25.4907 9.72583 25.4907 9.72651C26.3448 10.5824 26.7049 10.991 26.8009 11.1835C26.8294 11.2407 26.8395 11.3344 26.8555 11.4124H23.8105L23.8105 8.35671Z"
                        fill="#265D91"
                      />
                      <path
                        d="M15.5265 20.7543C15.3894 20.7523 15.2532 20.7777 15.1259 20.829C14.9986 20.8802 14.8827 20.9564 14.785 21.0529C14.6873 21.1494 14.6097 21.2645 14.5568 21.3913C14.5038 21.5181 14.4766 21.6543 14.4766 21.7918C14.4766 21.9292 14.5038 22.0654 14.5568 22.1922C14.6097 22.3191 14.6873 22.4341 14.785 22.5306C14.8827 22.6272 14.9986 22.7033 15.1259 22.7545C15.2532 22.8058 15.3894 22.8312 15.5265 22.8293H23.8104C23.9476 22.8312 24.0838 22.8058 24.2111 22.7545C24.3384 22.7033 24.4542 22.6272 24.5519 22.5306C24.6496 22.4341 24.7272 22.3191 24.7802 22.1922C24.8331 22.0654 24.8604 21.9292 24.8604 21.7918C24.8604 21.6543 24.8331 21.5181 24.7802 21.3913C24.7272 21.2645 24.6496 21.1494 24.5519 21.0529C24.4542 20.9564 24.3384 20.8802 24.2111 20.829C24.0838 20.7777 23.9476 20.7523 23.8104 20.7543H15.5265Z"
                        fill="#265D91"
                      />
                      <path
                        d="M15.5265 16.6041C15.3894 16.6022 15.2532 16.6276 15.1259 16.6788C14.9986 16.7301 14.8827 16.8062 14.785 16.9027C14.6873 16.9993 14.6097 17.1143 14.5568 17.2411C14.5038 17.368 14.4766 17.5041 14.4766 17.6416C14.4766 17.7791 14.5038 17.9152 14.5568 18.0421C14.6097 18.1689 14.6873 18.2839 14.785 18.3805C14.8827 18.477 14.9986 18.5531 15.1259 18.6044C15.2532 18.6557 15.3894 18.6811 15.5265 18.6791H23.8104C23.9476 18.6811 24.0838 18.6557 24.2111 18.6044C24.3384 18.5531 24.4542 18.477 24.5519 18.3805C24.6496 18.2839 24.7272 18.1689 24.7802 18.0421C24.8331 17.9152 24.8604 17.7791 24.8604 17.6416C24.8604 17.5041 24.8331 17.368 24.7802 17.2411C24.7272 17.1143 24.6496 16.9993 24.5519 16.9027C24.4542 16.8062 24.3384 16.7301 24.2111 16.6788C24.0838 16.6276 23.9476 16.6022 23.8104 16.6041H15.5265Z"
                        fill="#265D91"
                      />
                      <path
                        d="M15.5265 24.9042C15.3894 24.9022 15.2532 24.9276 15.1259 24.9789C14.9986 25.0301 14.8827 25.1063 14.785 25.2028C14.6873 25.2993 14.6097 25.4144 14.5568 25.5412C14.5038 25.668 14.4766 25.8042 14.4766 25.9417C14.4766 26.0792 14.5038 26.2153 14.5568 26.3421C14.6097 26.469 14.6873 26.584 14.785 26.6805C14.8827 26.7771 14.9986 26.8532 15.1259 26.9044C15.2532 26.9557 15.3894 26.9811 15.5265 26.9792H23.8104C23.9476 26.9811 24.0838 26.9557 24.2111 26.9044C24.3384 26.8532 24.4542 26.7771 24.5519 26.6805C24.6496 26.584 24.7272 26.469 24.7802 26.3421C24.8331 26.2153 24.8604 26.0792 24.8604 25.9417C24.8604 25.8042 24.8331 25.668 24.7802 25.5412C24.7272 25.4144 24.6496 25.2993 24.5519 25.2028C24.4542 25.1063 24.3384 25.0301 24.2111 24.9789C24.0838 24.9276 23.9476 24.9022 23.8104 24.9042H15.5265Z"
                        fill="#265D91"
                      />
                    </g>
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_126_200"
                      x="2.20117"
                      y="2.07495"
                      width="30.7852"
                      height="37.052"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_126_200"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_126_200"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
                Documents
              </h2>
            </div>
            <!--end::Card title-->
            <!--begin::Card toolbar-->

            <!--end::Card toolbar-->
          </div>
          <!--end::Card header-->
          <!--begin::Card body-->

          <!--end::Card body-->
        </div>
        <div class="content">
          <div class="row mb-4">
            <div class="table-responsive">
              <table class="table table-bordless documents">
                <tbody>
                  <tr class="cv">
                    <td>
                      <div class="title">
                        <h4>CV</h4>
                      </div>
                    </td>
                    <td>
                      <div class="tools">
                        <button
                          [disabled]="!selectedCandidate?.cv"
                          class="voir cursor-pointer"
                          (click)="OpenPDF()"
                        >
                          <svg
                            width="16"
                            height="10"
                            viewBox="0 0 16 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M14.9075 4.11569C14.7809 3.94157 11.5991 0 7.53093 0C3.46272 0 0.296805 3.9574 0.154339 4.11569C-0.0514462 4.36897 -0.0514462 4.71722 0.154339 4.97049C0.280975 5.14462 3.46272 9.08619 7.53093 9.08619C11.5991 9.08619 14.7651 5.12879 14.9075 4.97049C15.0975 4.71722 15.0975 4.36897 14.9075 4.11569ZM7.53093 7.70901C4.85573 7.70901 2.51295 5.49287 1.62649 4.54309C2.51295 3.59332 4.87156 1.37717 7.53093 1.37717C10.1903 1.37717 12.5489 3.59332 13.4354 4.54309C12.5489 5.49287 10.2061 7.70901 7.53093 7.70901Z"
                              fill="white"
                            />
                            <path
                              d="M7.53091 6.63263C8.68492 6.63263 9.62042 5.69712 9.62042 4.54312C9.62042 3.38912 8.68492 2.45361 7.53091 2.45361C6.37691 2.45361 5.44141 3.38912 5.44141 4.54312C5.44141 5.69712 6.37691 6.63263 7.53091 6.63263Z"
                              fill="white"
                            />
                          </svg>
                          Voir
                        </button>
                        <button
                          [disabled]="!selectedCandidate?.cv"
                          class="download"
                          (click)="downloadFile()"
                        >
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.30402 8.91765C5.64622 9.20165 5.98842 9.03125 6.10249 8.91765L9.52447 5.50963C9.75261 5.28243 9.75261 4.94163 9.52447 4.71443C9.29634 4.48723 8.95414 4.48723 8.72601 4.71443L6.27359 7.15684V0.568003C6.27359 0.227201 6.04545 0 5.70325 0C5.36106 0 5.13292 0.227201 5.13292 0.568003V7.15684L2.6805 4.71443C2.45237 4.48723 2.11017 4.48723 1.88204 4.71443C1.6539 4.94163 1.6539 5.28243 1.88204 5.50963L5.30402 8.91765Z"
                              fill="#265D91"
                            />
                            <path
                              d="M10.8363 9.08789C10.4941 9.08789 10.266 9.31509 10.266 9.65589V10.2239H1.14066V9.65589C1.14066 9.31509 0.91253 9.08789 0.570331 9.08789C0.228132 9.08789 0 9.31509 0 9.65589V10.7919C0 11.1327 0.228132 11.3599 0.570331 11.3599H10.8363C11.1785 11.3599 11.4066 11.1327 11.4066 10.7919V9.65589C11.4066 9.31509 11.1785 9.08789 10.8363 9.08789Z"
                              fill="#265D91"
                            />
                          </svg>

                          Télécharger
                        </button>
                      </div>
                    </td>
                  </tr>

                  <tr class="test">
                    <td>
                      <div class="title mb-4">
                        <h4>Test QCM</h4>
                      </div>
                      <div class="reponse mb-2">Réponses correctes :</div>
                      <span
                        >Score :
                        <span class="score"
                          >{{ selectedCandidate?.score }}
                          <span
                            *ngIf="
                              selectedCandidate && selectedCandidate?.score
                            "
                            >%</span
                          ></span
                        ></span
                      >
                    </td>
                    <td>
                      <div class="tools">
                        <button
                          class="voir"
                          (click)="openResultTest()"
                          [disabled]="!show_test"
                          [title]="!show_test ? 'test non passé' : ''"
                        >
                          <svg
                            width="16"
                            height="10"
                            viewBox="0 0 16 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M14.9075 4.11569C14.7809 3.94157 11.5991 0 7.53093 0C3.46272 0 0.296805 3.9574 0.154339 4.11569C-0.0514462 4.36897 -0.0514462 4.71722 0.154339 4.97049C0.280975 5.14462 3.46272 9.08619 7.53093 9.08619C11.5991 9.08619 14.7651 5.12879 14.9075 4.97049C15.0975 4.71722 15.0975 4.36897 14.9075 4.11569ZM7.53093 7.70901C4.85573 7.70901 2.51295 5.49287 1.62649 4.54309C2.51295 3.59332 4.87156 1.37717 7.53093 1.37717C10.1903 1.37717 12.5489 3.59332 13.4354 4.54309C12.5489 5.49287 10.2061 7.70901 7.53093 7.70901Z"
                              fill="white"
                            />
                            <path
                              d="M7.53091 6.63263C8.68492 6.63263 9.62042 5.69712 9.62042 4.54312C9.62042 3.38912 8.68492 2.45361 7.53091 2.45361C6.37691 2.45361 5.44141 3.38912 5.44141 4.54312C5.44141 5.69712 6.37691 6.63263 7.53091 6.63263Z"
                              fill="white"
                            />
                          </svg>
                          Voir
                        </button>

                        <button
                          class="download"
                          [disabled]="!show_test"
                          (click)="downloadResultTest()"
                          [title]="!show_test ? 'test non passé' : ''"
                        >
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.30402 8.91765C5.64622 9.20165 5.98842 9.03125 6.10249 8.91765L9.52447 5.50963C9.75261 5.28243 9.75261 4.94163 9.52447 4.71443C9.29634 4.48723 8.95414 4.48723 8.72601 4.71443L6.27359 7.15684V0.568003C6.27359 0.227201 6.04545 0 5.70325 0C5.36106 0 5.13292 0.227201 5.13292 0.568003V7.15684L2.6805 4.71443C2.45237 4.48723 2.11017 4.48723 1.88204 4.71443C1.6539 4.94163 1.6539 5.28243 1.88204 5.50963L5.30402 8.91765Z"
                              fill="#265D91"
                            />
                            <path
                              d="M10.8363 9.08789C10.4941 9.08789 10.266 9.31509 10.266 9.65589V10.2239H1.14066V9.65589C1.14066 9.31509 0.91253 9.08789 0.570331 9.08789C0.228132 9.08789 0 9.31509 0 9.65589V10.7919C0 11.1327 0.228132 11.3599 0.570331 11.3599H10.8363C11.1785 11.3599 11.4066 11.1327 11.4066 10.7919V9.65589C11.4066 9.31509 11.1785 9.08789 10.8363 9.08789Z"
                              fill="#265D91"
                            />
                          </svg>
                          Télécharger
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="card card-right pt-4 mb-6 mb-xl-9">
          <!--begin::Card header-->
          <div class="card-header border-0">
            <!--begin::Card title-->
            <div class="card-title flex-column">
              <h2 class="mb-1">
                <svg
                  width="42"
                  height="34"
                  viewBox="0 0 42 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_126_371)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M31.5274 5.73584C34.5796 5.73584 37.0474 8.21559 37.0474 11.2878C37.0474 14.3574 34.5796 16.835 31.5274 16.835C28.4744 16.835 26.0092 14.3574 26.0092 11.2878C26.0092 8.21559 28.4744 5.73584 31.5274 5.73584ZM27.3148 0.00999332C24.4288 -0.098337 21.8365 0.6714 19.8395 2.46943C17.8435 0.670977 15.2507 -0.098337 12.3668 0.00999332C9.48083 0.117477 6.90367 1.14281 5.50548 2.73179C5.41502 2.83335 5.36747 2.96326 5.36495 3.09995V5.55303L4.50365 6.43703C4.1115 6.83819 4 7.06077 4 7.60073V23.6019C4 24.642 4.69426 25.2683 5.43311 25.2683H34.2464C34.9869 25.2683 35.682 24.6403 35.682 23.6019V19.5712C35.682 17.7618 33.2012 17.7618 33.2012 19.5712V21.9426C31.7311 20.7925 29.7257 19.9588 27.4158 19.8247C24.7772 19.6724 21.9699 20.4154 19.8395 22.3328C17.7092 20.4154 14.9023 19.6724 12.2642 19.8247C9.95419 19.9593 7.94884 20.7925 6.4787 21.9426V3.38177C7.60466 2.19141 9.85952 1.21982 12.3298 1.07637C12.6471 1.05648 12.9677 1.05183 13.2896 1.0586C15.5331 1.11615 17.7997 1.84103 19.4449 3.49603C19.662 3.7165 20.0167 3.7165 20.2338 3.49603C22.1167 1.60533 24.8079 0.929108 27.3497 1.07637C29.8217 1.21982 32.0744 2.19183 33.2008 3.38177V5.00588C32.666 4.86031 32.1068 4.77653 31.5266 4.77653C27.9569 4.77653 25.0549 7.69679 25.0549 11.2869C25.0549 14.8771 27.9564 17.7952 31.5266 17.7952C35.0968 17.7952 38 14.8771 38 11.2869C38 8.70181 36.4903 6.4713 34.3141 5.42016V3.0991C34.3141 2.96242 34.2632 2.83293 34.1736 2.73095C32.7767 1.14281 30.1995 0.117477 27.3148 0.00999332Z"
                      fill="#265D91"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M19.8318 5.28815C19.5247 5.29492 19.2794 5.54839 19.2836 5.85688V19.1713C19.2596 19.9424 20.4209 19.9424 20.3969 19.1713V5.85688C20.4015 5.54162 20.1449 5.28349 19.8318 5.28815Z"
                      fill="#265D91"
                    />
                    <path
                      d="M30.8436 9.9585C30.1022 9.99573 30.1598 11.1154 30.9004 11.0782H31.4066V14.8092C31.367 15.5938 32.5569 15.5938 32.5178 14.8092V10.5183C32.5178 10.2094 32.2704 9.96019 31.9632 9.9585H30.8436Z"
                      fill="#265D91"
                    />
                    <path
                      d="M31.7483 9.05268C32.2516 9.05268 32.6597 8.65198 32.6597 8.15769C32.6597 7.6634 32.2516 7.2627 31.7483 7.2627C31.2449 7.2627 30.8369 7.6634 30.8369 8.15769C30.8369 8.65198 31.2449 9.05268 31.7483 9.05268Z"
                      fill="#265D91"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_126_371"
                      x="0"
                      y="0"
                      width="42"
                      height="33.2683"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_126_371"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_126_371"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
                Informations professionnelles
              </h2>
            </div>
            <!--end::Card title-->
            <!--begin::Card toolbar-->

            <!--end::Card toolbar-->
          </div>
          <!--end::Card header-->
          <!--begin::Card body-->

          <!--end::Card body-->
        </div>

        <div class="content2 pb-5 fs-6">
          <!--begin::Details item-->
          <!--begin::Details item-->
          <div class="flex-space">
            <div
              class="title-info"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
            >
              Date de début de première expérience professionnelle
            </div>
            <div class="text-gray-600">
              {{
                Candidate_info?.date_first_experience
                  ? Candidate_info.date_first_experience
                  : "---"
              }}
            </div>
          </div>

          <!--begin::Details item-->
          <!--begin::Details item-->
          <div class="flex-space">
            <div class="title-info">Niveau en Anglais</div>
            <div class="text-gray-600">
              {{
                Candidate_info?.english_level
                  ? Candidate_info.english_level
                  : "---"
              }}
            </div>
          </div>
          <!--begin::Details item-->
          <!--begin::Details item-->
          <div class="flex-space">
            <div class="title-info">Niveau en Français</div>
            <div class="text-gray-600">
              {{
                Candidate_info?.frensh_level
                  ? Candidate_info.frensh_level
                  : "---"
              }}
            </div>
          </div>
          <div class="flex-space">
            <div class="title-info">Disponibilité</div>
            <div class="text-gray-600">
              {{
                Candidate_info?.availability
                  ? Candidate_info.availability
                  : "---"
              }}
            </div>
          </div>

          <div class="flex-space">
            <div class="title-info">Intéressé par</div>
            <div class="text-gray-600">
              {{
                Candidate_info?.desired_contract &&
                Candidate_info.desired_contract.length > 0
                  ? Candidate_info.desired_contract
                  : "---"
              }}
            </div>
          </div>
          <div class="flex-space">
            <div class="title-info">Poste souhaité</div>
            <div class="text-gray-600">
              {{
                Candidate_info?.desired_workstation !== null &&
                Candidate_info.desired_workstation !== undefined
                  ? Candidate_info.desired_workstation
                  : "---"
              }}
            </div>
          </div>
          <div class="flex-space">
            <div class="title-info">
              Salaire brute/an souhaité (pour un CDI Français)
            </div>
            <div class="text-gray-600">
              {{Candidate_info.desired_salary && Candidate_info.desired_salary!='null' && Candidate_info.desired_salary!='0' ?Candidate_info.desired_salary+' €':'---'}} 
              </div>

              <!-- {{
                Candidate_info?.desired_salary
                  ? Candidate_info.desired_salary + "€"
                  : "---"
              }} -->
            
          </div>

          <div class="flex-space">
            <div class="title-info">Société</div>
            <div class="text-gray-600">ITGATE GROUP</div>
          </div>
        </div>
      </div>
      <!--end::Content-->
    </div>
    <div class="card card3 pt-4 mb-6 mb-xl-9">
      <!--begin::Card header-->
      <div class="card-header border-0">
        <!--begin::Card title-->
        <div class="card-title flex-column">
          <h2 class="mb-1 info-person">
            <svg
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_126_343)">
                <path
                  d="M11.101 0.00083786C10.2458 0.00083786 9.53345 0.714159 9.53345 1.57104V1.75817C9.355 1.82241 9.17684 1.89502 9.00313 1.97602L8.87209 1.84475C8.26677 1.23812 7.25968 1.23812 6.65436 1.84475L5.84076 2.65945C5.23545 3.26608 5.23545 4.2749 5.84076 4.88097L5.97181 5.01224C5.89095 5.1854 5.81846 5.36304 5.75433 5.54346H5.56752C4.7121 5.54346 4 6.25678 4 7.11366V8.26799C4 9.12515 4.7121 9.83847 5.56752 9.83847H5.75433C5.81846 10.02 5.89095 10.196 5.97181 10.3694L5.84076 10.5007C5.23545 11.1073 5.23545 12.1158 5.84076 12.7222L6.65436 13.5372C7.25968 14.1438 8.26677 14.1438 8.87209 13.5372L9.00313 13.4059C9.176 13.4869 9.35361 13.5595 9.53345 13.6238V13.8109C9.53345 14.6681 10.2458 15.3814 11.101 15.3814H12.2533C13.109 15.3814 13.8214 14.6681 13.8214 13.8109V13.6238C13.9999 13.5595 14.178 13.4869 14.3514 13.4059L14.4825 13.5372C15.0881 14.1438 16.0952 14.1438 16.7002 13.5372L17.5141 12.7222C18.1194 12.1158 18.1194 11.1073 17.5141 10.5007L17.383 10.3694C17.4639 10.1962 17.5364 10.0189 17.6005 9.83847H17.7873C18.643 9.83847 19.3551 9.12515 19.3551 8.26799V7.11366C19.3551 6.25678 18.643 5.54346 17.7873 5.54346H17.6033C17.5392 5.36192 17.4639 5.18541 17.383 5.0114L17.5141 4.88014C18.1194 4.27406 18.1194 3.26525 17.5141 2.65862L16.7002 1.84391C16.0952 1.23728 15.0881 1.23728 14.4825 1.84391L14.3514 1.97518C14.1786 1.89418 14.0007 1.81877 13.8206 1.75454V1.5702C13.8206 0.713321 13.1082 0 12.2525 0L11.101 0.00083786ZM11.101 1.46574H12.2533C12.3258 1.46574 12.3593 1.49926 12.3593 1.57188V2.29246C12.3592 2.45441 12.4128 2.61181 12.5115 2.74006C12.6102 2.8683 12.7486 2.96018 12.9049 3.00131C13.3321 3.11303 13.7419 3.2834 14.1228 3.50684C14.2624 3.58865 14.4252 3.62178 14.5856 3.60106C14.7461 3.58034 14.8951 3.50694 15.0095 3.39233L15.5175 2.88317C15.5677 2.8329 15.6151 2.8329 15.6652 2.88317L16.4788 3.69816C16.529 3.74843 16.529 3.79591 16.4788 3.84618L15.9708 4.35562C15.8564 4.47016 15.7831 4.61946 15.7624 4.78017C15.7418 4.94087 15.7748 5.10391 15.8565 5.24378C16.0796 5.6253 16.2491 6.03558 16.3612 6.46346C16.4022 6.6201 16.4938 6.75873 16.6218 6.85767C16.7498 6.95661 16.9069 7.01029 17.0685 7.01032H17.7879C17.8604 7.01032 17.8938 7.04384 17.8938 7.11646V8.27079C17.8938 8.3434 17.8604 8.37692 17.7879 8.37692H17.0652C16.9032 8.37685 16.7458 8.43065 16.6176 8.52987C16.4894 8.6291 16.3978 8.76814 16.357 8.92518C16.2455 9.35278 16.0773 9.76334 15.8557 10.1451C15.7744 10.2848 15.7416 10.4475 15.7622 10.6079C15.7829 10.7682 15.856 10.9172 15.97 11.0316L16.478 11.5408C16.5282 11.5911 16.5282 11.6385 16.478 11.6888L15.6644 12.5041C15.6142 12.5543 15.5668 12.5543 15.5166 12.5041L15.0086 11.9949C14.8944 11.8806 14.7456 11.8074 14.5855 11.7867C14.4253 11.766 14.2629 11.7989 14.1234 11.8804C13.7422 12.1038 13.3324 12.2717 12.9055 12.3829C12.7488 12.4237 12.61 12.5155 12.5109 12.6438C12.4119 12.7721 12.3582 12.9298 12.3582 13.092V13.8159C12.3582 13.8885 12.3247 13.9221 12.2522 13.9221H11.0999C11.0274 13.9221 10.9939 13.8885 10.9939 13.8159V13.092C10.9939 12.9298 10.9402 12.7722 10.8412 12.6439C10.7422 12.5155 10.6035 12.4237 10.4469 12.3829C10.0197 12.2711 9.61012 12.1027 9.22898 11.8804C9.08949 11.7989 8.92702 11.766 8.76689 11.7867C8.60676 11.8074 8.45797 11.8806 8.34372 11.9949L7.83544 12.5041C7.78525 12.5543 7.73785 12.5543 7.68766 12.5041L6.87435 11.6888C6.82416 11.6385 6.82416 11.5911 6.87435 11.5408L7.38236 11.0316C7.49638 10.9172 7.56942 10.7682 7.5901 10.6079C7.61077 10.4475 7.57793 10.2848 7.49667 10.1451C7.2764 9.76334 7.10605 9.35278 6.99508 8.92518C6.95431 8.76818 6.86269 8.62918 6.73457 8.52996C6.60646 8.43074 6.44909 8.37691 6.28715 8.37692H5.56418C5.49168 8.37692 5.45822 8.3434 5.45822 8.27079V7.11646C5.45822 7.04384 5.49168 7.01032 5.56418 7.01032H6.28715C6.44909 7.01033 6.60646 6.95651 6.73457 6.85729C6.86269 6.75806 6.95431 6.61906 6.99508 6.46207C7.1066 6.03419 7.27501 5.6239 7.49667 5.2421C7.57793 5.10241 7.61077 4.93972 7.5901 4.77938C7.56942 4.61903 7.49638 4.47004 7.38236 4.35562L6.87435 3.84646C6.82416 3.79619 6.82416 3.74871 6.87435 3.69843L7.68766 2.88373C7.73785 2.83346 7.78525 2.83346 7.83544 2.88373L8.34372 3.39261C8.45797 3.50689 8.60676 3.58009 8.76689 3.60081C8.92702 3.62152 9.08949 3.58858 9.22898 3.50712C9.61012 3.28368 10.0197 3.11582 10.4469 3.00466C10.6035 2.96378 10.7422 2.87198 10.8412 2.74365C10.9402 2.61532 10.9939 2.45771 10.9939 2.29553V1.57132C10.9939 1.4987 11.0285 1.46574 11.101 1.46574ZM21.4672 4.02968C21.4043 4.02144 21.3405 4.02144 21.2776 4.02968C21.1512 4.05243 21.0333 4.1081 20.9352 4.19111C20.8372 4.27411 20.7626 4.38152 20.7191 4.50253C20.6866 4.59307 20.6722 4.68913 20.6768 4.78523C20.6814 4.88134 20.7048 4.9756 20.7457 5.06264C20.7866 5.14968 20.8443 5.22779 20.9154 5.29251C20.9864 5.35723 21.0695 5.4073 21.1599 5.43984C24.0602 6.48469 26.1374 9.25698 26.1377 12.5264C26.1366 12.6074 26.1374 12.6018 26.1371 12.694C26.1369 12.789 26.1366 12.9146 26.1363 13.0398C26.1357 13.2883 26.1349 13.5361 26.1349 13.5361C26.1349 13.6299 26.1529 13.7228 26.1879 13.8098L27.6952 17.5912H26.3738C26.2778 17.5911 26.1827 17.6101 26.0939 17.6469C26.0051 17.6837 25.9245 17.7376 25.8566 17.8057C25.7886 17.8737 25.7347 17.9545 25.6979 18.0434C25.6612 18.1323 25.6422 18.2275 25.6422 18.3238V21.0497H22.0304C21.8644 21.0497 21.7034 21.1064 21.5738 21.2102C21.4442 21.314 21.3537 21.4589 21.3172 21.6211L20.6918 24.3982H14.2979L15.1221 19.7605C15.1483 19.6134 15.129 19.4619 15.0668 19.3262C15.0046 19.1905 14.9025 19.077 14.7741 19.001C14.0475 18.5712 13.4104 18.0299 12.879 17.4063C12.753 17.2586 12.5736 17.1671 12.3802 17.1519C12.1868 17.1367 11.9954 17.1991 11.8479 17.3253C11.7006 17.4515 11.6093 17.6312 11.5941 17.8248C11.579 18.0184 11.6412 18.2101 11.7671 18.3578C12.2935 18.9759 12.9083 19.5244 13.5967 19.9872L12.7056 25.0028C12.6868 25.1082 12.6914 25.2164 12.7189 25.3199C12.7464 25.4233 12.7963 25.5195 12.8648 25.6015C12.9334 25.6836 13.0192 25.7496 13.116 25.795C13.2128 25.8403 13.3183 25.8638 13.4252 25.8639H21.2773C21.4433 25.8639 21.6044 25.8073 21.7341 25.7035C21.8637 25.5996 21.9543 25.4547 21.9908 25.2925L22.6159 22.5154H26.3744C26.5684 22.5154 26.7544 22.4382 26.8915 22.3008C27.0287 22.1634 27.1057 21.9771 27.1057 21.7828V19.0569H28.7753C28.8948 19.0569 29.0125 19.0276 29.1181 18.9716C29.2237 18.9155 29.3139 18.8344 29.381 18.7353C29.448 18.6362 29.4898 18.5221 29.5027 18.4031C29.5155 18.2841 29.4991 18.1637 29.4548 18.0526L27.5993 13.3989C27.5995 13.3124 27.5998 13.223 27.6004 13.0445C27.6006 12.9188 27.6009 12.7959 27.6012 12.699C27.6015 12.6041 27.6034 12.4532 27.6018 12.5454C27.602 8.65286 25.1247 5.32729 21.6562 4.07772C21.5961 4.05561 21.5332 4.04153 21.4694 4.03582L21.4672 4.02968ZM11.6773 4.12185C9.71663 4.12185 8.11175 5.72947 8.11175 7.69348C8.11175 9.65749 9.71663 11.2654 11.6773 11.2654C13.6382 11.2654 15.2431 9.65749 15.2431 7.69348C15.2431 5.72947 13.6382 4.12185 11.6773 4.12185ZM11.6773 5.58675C12.8475 5.58675 13.7804 6.52128 13.7804 7.69348C13.7804 8.86569 12.8475 9.80021 11.6773 9.80021C10.5074 9.80021 9.57443 8.86569 9.57443 7.69348C9.57443 6.52128 10.5074 5.58675 11.6773 5.58675Z"
                  fill="#265D91"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_126_343"
                  x="0"
                  y="0"
                  width="33.5068"
                  height="33.8638"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_126_343"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_126_343"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>

            Compétences maitrisées
          </h2>
        </div>
        <!--end::Card title-->
        <!--begin::Card toolbar-->

        <!--end::Card toolbar-->
      </div>
      <!--end::Card header-->
      <!--begin::Card body-->

      <!--end::Card body-->
    </div>
    <div class="container">
      <div class="table-responsive compt">
        <table
          class="table align-middle fs-6 gy-5 mb-0"
          id="kt_customers_table"
        >
          <thead>
            <tr class="text-start fw-bold fs-7 text-uppercase gs-0">
              <th class="min-w-200px">Catégories</th>
              <th class="min-w-200px">Modules</th>
            </tr>
          </thead>
          <tbody class="fw-semibold">
            <tr
              class="bg1"
              *ngFor="let skill of skills; let i = index"
              [style.background-color]="colorsHeader[i]"
            >
              <td>
                <div>
                  {{ skill?.name_FR }}
                </div>
              </td>
              <td>
                <div class="brd-compt">
                  <ng-container *ngFor="let subSkill of skill?.sub_category">
                    <div class="badge badge-light-default">
                      {{ subSkill?.name_FR }}
                    </div>
                  </ng-container>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="alert alert-warning text-center mt-5"
        role="alert"
        *ngIf="!skills.length"
      >
        <img src="/assets/media/errors/no-data.png" alt="" class="mb-5" />
        <span class="empty-list"> La liste est vide </span>
      </div>
    </div>
  </div>
  <!--end::Content container-->
</div>
